import { PAYMENT_MODE } from '@/domain/payment/payment-mode'
import { PaymentTiming, parsePaymentTiming } from '@/types/enums/PaymentTiming'

/** Stable enum name for URLs and analytics (e.g. `AtDelivery`). */
export function paymentTimingToCode(timing: PaymentTiming): string {
  return PaymentTiming[timing] ?? 'Unknown'
}

/** Legacy orders: infer COD from payment method labels when timing/mode are absent. */
export function inferCodFromPaymentMethod(...methods: unknown[]): boolean {
  for (const method of methods) {
    if (method == null || method === '') continue
    const normalized = String(method).trim().toLowerCase()
    if (!normalized) continue
    if (normalized === 'cash' || normalized === 'cod' || normalized === '2') return true
    if (normalized.includes('cash on delivery') || normalized.includes('cash_on_delivery')) return true
  }
  return false
}

/**
 * Authoritative post-order timing: API `payment_timing` first, then legacy `payment_mode`.
 */
export function resolvePaymentTimingFromOrder(
  raw: {
    payment_timing?: unknown
    payment_mode?: unknown
    payment_method?: unknown
    primary_payment_method?: unknown
  } | null | undefined
): PaymentTiming {
  if (raw == null) return PaymentTiming.Unknown
  const fromTiming = parsePaymentTiming(raw.payment_timing)
  if (fromTiming !== PaymentTiming.Unknown) return fromTiming
  const mode = String(raw.payment_mode ?? '').trim().toUpperCase()
  if (mode === PAYMENT_MODE.COD) return PaymentTiming.AtDelivery
  if (mode === PAYMENT_MODE.ONLINE) return PaymentTiming.BeforeFulfillment
  if (inferCodFromPaymentMethod(raw.payment_method, raw.primary_payment_method)) {
    return PaymentTiming.AtDelivery
  }
  return PaymentTiming.Unknown
}
